import { useCallback, useMemo, useState } from 'react';
import ImageLightboxModal from '../components/common/ImageLightboxModal';

/**
 * Open a lightbox from any page (single image or gallery).
 */
export const useImageLightbox = () => {
  const [state, setState] = useState(null);

  const openLightbox = useCallback((images, startIndex = 0) => {
    const list = Array.isArray(images) ? images.filter((s) => s?.url) : [];
    if (list.length === 0) return;
    const maxIndex = list.length - 1;
    setState({
      images: list,
      startIndex: Math.max(0, Math.min(startIndex, maxIndex)),
    });
  }, []);

  const closeLightbox = useCallback(() => setState(null), []);

  const Lightbox = useMemo(
    () =>
      state ? (
        <ImageLightboxModal
          isOpen
          images={state.images}
          startIndex={state.startIndex}
          onClose={closeLightbox}
        />
      ) : null,
    [state, closeLightbox],
  );

  return { openLightbox, closeLightbox, Lightbox, isOpen: !!state };
};

export default useImageLightbox;
